import { render, staticRenderFns } from "./GraficoBarrasProducaoAgricola.vue?vue&type=template&id=0bfdb0d2&lang=pug"
import script from "./GraficoBarrasProducaoAgricola.vue?vue&type=script&lang=js"
export * from "./GraficoBarrasProducaoAgricola.vue?vue&type=script&lang=js"
import style0 from "./GraficoBarrasProducaoAgricola.vue?vue&type=style&index=0&id=0bfdb0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports